import React, { Suspense } from 'react';
import FinalModel from './FinalModel';

const App = () => {
  return (
    <Suspense fallback={null}>
      <FinalModel />
    </Suspense>
  );
}

export default App;
